var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8263 6.66732C16.8269 6.38408 16.7552 6.10536 16.6182 5.85749C16.4811 5.60962 16.2832 5.40077 16.043 5.25065L8.5013 0.833984L0.959635 5.25065C0.488802 5.54648 0.167969 6.06732 0.167969 6.66732V15.0007C0.167969 15.9215 0.913802 16.6673 1.83464 16.6673H15.168C16.0888 16.6673 16.8346 15.9215 16.8346 15.0007L16.8263 6.66732ZM8.5013 10.834L1.61797 6.52982L8.5013 2.50065L15.3846 6.52982L8.5013 10.834Z",
    fill: "#F44646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.11a403d2ba9475d40ab20b78840c2436.svg";
export { ForwardRef as ReactComponent };